import { render, staticRenderFns } from "./name-hospital-dialog.vue?vue&type=template&id=5942b1c2&scoped=true"
import script from "./name-hospital-dialog.vue?vue&type=script&lang=js"
export * from "./name-hospital-dialog.vue?vue&type=script&lang=js"
import style0 from "./name-hospital-dialog.vue?vue&type=style&index=0&id=5942b1c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5942b1c2",
  null
  
)

export default component.exports